import { Link } from "react-router-dom";
import { useBrowseHistory } from "@/hooks/useBrowseHistory";

export default function BrowseHistoryRail() {
  const { history, clear } = useBrowseHistory();

  if (history.length === 0) return null;

  return (
    <section className="rounded-lg border border-background-200 bg-background-100/60 p-4">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
          <span className="flex h-4 w-4 items-center justify-center text-accent-600">
            <i className="ri-history-line"></i>
          </span>
          浏览足迹
          <span className="text-xs font-normal text-foreground-500">（最近 {history.length} 条）</span>
        </h3>
        <button
          type="button"
          onClick={clear}
          className="whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-accent-600"
        >
          清空
        </button>
      </div>
      <ul className="mt-3 space-y-2">
        {history.map((item) => (
          <li key={`${item.type}-${item.id}`}>
            <Link
              to={item.path}
              className="group flex items-center gap-3 rounded-md p-1.5 transition-colors hover:bg-background-200"
            >
              <img
                src={item.cover}
                alt={item.title}
                className="h-10 w-10 shrink-0 rounded-md object-cover object-top"
              />
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                  {item.title}
                </span>
                <span className="block truncate text-xs text-foreground-500">{item.subtitle}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-[11px] leading-relaxed text-foreground-400">
        浏览足迹保存在本机浏览器中，用于演示推荐效果，清除浏览器数据后将被重置。
      </p>
    </section>
  );
}